// src/components/common/AwaitRole.js
import React from 'react';
import { Typography, Container } from '@mui/material';

const AwaitRole = () => {
  return (
    <Container style={{ textAlign: 'center', marginTop: '20%' }}>
      <Typography variant="h4">Por favor, espere</Typography>
      <Typography variant="body1" color="textSecondary">
        Su cuenta está en proceso de asignación de permisos. Contacte con el administrador si este mensaje persiste.
      </Typography>
    </Container>
  );
};

export default AwaitRole;
